// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"Modal_modal-container__1pBfl","backdrop":"Modal_backdrop__3R4ST"};